export const SEND_EMAIL = 'SEND_EMAIL'
export const SENT_EMAIL = 'SENT_EMAIL'

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE'
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE'
export const RESET_SUCCESS_MESSAGE = 'RESET_SUCCESS_MESSAGE'

export const SET_LANGUAGE = 'SET_LANGUAGE'


// WEBPACK FOOTER //
// ./src/redux/actions/actionTypes.js